import { CmsApplianceCareCancellations } from '../../models/cms/cms-appliance-care-cancellations.interface';

export const mockCmsApplianceCareCancellations: CmsApplianceCareCancellations =
  {
    applianceCareCancellations:
      '*See complete Appliance Care Terms and Conditions for cancellation here',
  };
